import Vue from 'vue'
import axios from 'axios'
import router from '@/router'
import store from '@/vuex/store'
import messages from './messages'
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true // 允许axios跨域携带cookie信息
export const API_PRE = '/api/'
export const API_SUFFIX = '.vdt'
import sessionStorageUtil from '@/api/sessionStorageUtil'
import localStorageUtil from '@/api/localStorageUtil'
import cookieUtil from '@/api/cookieUtil'
import globalConfig from '@/config'

//TODO [xsw] 注意：用sessionStorageUtil设置的值用sessionStorage是无法直接取到的
function getAuthorization() {
  return (
    sessionStorageUtil.get('token_type') + ' ' + sessionStorageUtil.get('token')
  )
}

// 添加请求拦截器
/* var myInterceptor = axios.interceptors.request.use(
    config => {
        const token = sessionStorage.getItem("token"); //获取存储在本地的token
        config.data = JSON.stringify(config.data);
        config.headers = {
            'Content-Type': 'application/json' //设置跨域头部,虽然很多浏览器默认都是使用json传数据，但咱要考虑IE浏览器。
        };
        if (token) {
            config.headers.Authorization = "Token " + token; //携带权限参数
        }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
); */

axios.interceptors.response.use(
  response => {
    // 对响应数据做点什么
    console.log('响应拦截器then:' + response.status)
    console.log('响应拦截器response.this:' + this)
    var status = response.status
    var message = messages.message(response, '恭喜你，操作成功了！')
    //message = messages.message(response, '操作成功！');
    /* if (response.status && response.status == 200 && response.data.status == 'error') {
      //Message.error({ message: response.data.msg });
      return;
  } */
    return { status: status, message: message.message, response: response }
    //return response;
  },
  error => {
    // 对响应错误做点什么
    var message = ''
    console.error('cs-error:响应拦截器err：' + error)
    console.error('cs-error:响应拦截器err.this:' + this)
    //console.log('响应拦截器err：' + error.status);
    if(!error.response){
      console.error('cs-error:response is undefined')
      return
    }
    var status = error.response.status
    var return_data = {
      status: status,
      message: message.message
    }
    if (error.response.data) {
      if (error.response.data.rcode) {
        return_data.rcode = error.response.data.rcode
      }
      if (error.response.data.error_description) {
        return_data.get_token_error = error.response.data.error_description
      }
      // 生产环境下，open_id由后端返回
      if (error.response.data.open_id) {
        sessionStorageUtil.set('open_id', error.response.data.open_id)
      }
      if (error.response.data.messages) {
        return_data.msg = error.response.data.messages[0].msg //自定义错误消息
      }
    }
    //var msg = error.response.data.messages[0].msg
    if (status == 504 || status == 404) {
      console.log('服务器被吃了⊙﹏⊙∥')
      //Message.error({ message: '服务器被吃了⊙﹏⊙∥' });
      message = messages.message(error.response, '操作失败,服务器被吃了！')
    } else if (status == 401) {
      console.log('token过期')
      message = messages.message(
        error.response,
        '操作失败,response.data.error！'
      )
      //清空sessionStorage中的token相关
      sessionStorageUtil.remove('token')
      sessionStorageUtil.remove('token_type')
      sessionStorageUtil.remove('refresh_token')
      localStorageUtil.remove('token')
      //清空cookie中的token相关
      cookieUtil.remove('new_token')
      cookieUtil.remove('new_token_type')
      cookieUtil.remove('new_refresh_token')

      clearIntervalRefreshToken() //注销刷新令牌的定时器
      console.log('router:' + router)
    } else if (status == 403) {
      console.log('权限不足,请联系管理员!')
      message = messages.message(
        error.response,
        '操作失败,权限不足,请联系管理员！'
      )
    } else if (status == 400) {
      //console.log('错误请求!' + msg);
      message = messages.message(error.response, '操作失败,很遗憾，错误的请求!')
    } else if (status == 422) {
      console.log('语义错误,无法响应!')
      message = messages.message(error.response, '操作失败,语义错误,无法响应！')
    } else {
      //console.log('未知错误!');
      message = messages.message(error.response, '操作失败,未知错误！')
    }
    return return_data
    //return Promise.reject(error);
  }
)

export const getDomain = function() {
  return (
    // window.location.hostname ? window.location.hostname : sessionStorage.getItem('domain_name')
    sessionStorageUtil.get('domain_name')
      ? sessionStorageUtil.get('domain_name')
      : process.env.MAIN_DOMAIN_NAME
  )
}

/**
 * 设置域名（链接中有domain_name_all参数则设置）
 */
export const setDomain = function() {
  let promise = new Promise((resolve, reject) => {
    let query = router.currentRoute.query
    let domain_name = query.domain_name_all
    if (domain_name) {
      sessionStorageUtil.set('domain_name', domain_name)
      sessionStorageUtil.set(
        'web_type',
        domain_name == process.env.MAIN_DOMAIN_NAME ? 1 : 2
      )
      cookieUtil.set('new_domain_name', domain_name)
      cookieUtil.set('new_web_type', domain_name == process.env.MAIN_DOMAIN_NAME ? 1 : 2)
      resolve(1) //返回1代表有域名参数，且成功设置到sessionStorage
    } else {
      resolve(-1) //返回-1代表没有域名参数
    }
  })
  return promise
}

/**
 * 获取旧网站项目地址(如：http://visa.fengye.cc:9999)
 */
export const getOldWebUrl = function() {
  return (
    // window.location.hostname ? window.location.hostname : sessionStorage.getItem('domain_name')
    sessionStorageUtil.get('domain_name')
      ? 'http://' +
          sessionStorageUtil.get('domain_name') +
          ':' +
          process.env.OLD_WEB_PORT +
          '/'
      : process.env.OLD_WEB_URL
  )
}

/**
 * 获取当前网站项目地址(如：http://visa.fengye.cc:9191)
 */
export const getWebUrl = function() {
  let protocol = window.location.protocol
  let host = window.location.host
  return protocol + '//' + host + '/'
}

/**
 * 固定url参数
 */
export const addFixedUrlParam = function(url) {
  if (url.indexOf('?') < 0) {
    url += '?'
  } else {
    url += '&'
  }
  return (
    url +
    'domain_name=' +
    getDomain() +
    '&terminal_type=' +
    globalConfig.terminal_type
  )
}

export const get = (url, args = {}) => {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'get',
      params: args,
      headers: {
        Authorization: getAuthorization()
        // 'domain-name00': window.location.hostname
      },
      url: addFixedUrlParam(url)
      // url:url
    })
      .then(res => {
        if (res.status === 200) {
          //console.log('res'+res);
          resolve(res)
        } else {
          //console.error(res)
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
  return promise
}

export const deletes = (url, args = {}) => {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'delete',
      params: args,
      headers: { Authorization: getAuthorization() },
      url: addFixedUrlParam(url)
    })
      .then(res => {
        if (res.status === 200) {
          resolve(res)
        } else {
          console.error(res)
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
  return promise
}

export const post = function(url, data, params = {}, ignoreError) {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'post',
      params: params,
      data: JSON.stringify(data), //Qs.stringify(data)
      headers: {
        // 'Content-type': 'application/x-www-form-urlencoded',
        'Content-type': 'application/json;charset=UTF-8',
        Authorization: getAuthorization()
      },
      url: addFixedUrlParam(url)
    })
      .then(res => {
        if (res.status === 200) {
          resolve(res)
        } else {
          console.log('post.then.reject=' + res)
          reject(res)
        }
      })
      .catch(err => {
        console.log('post.catch.reject=' + err)
        reject(err)
      })
  })
  return promise
}

export const put = function(url, args, params = {}, ignoreError) {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'put',
      params: params,
      data: JSON.stringify(args),
      headers: {
        'Content-type': 'application/json;charset=UTF-8',
        Authorization: getAuthorization()
      },
      url: addFixedUrlParam(url)
    })
      .then(res => {
        if (res.status === 200) {
          //console.log('res'+res);
          resolve(res)
        } else {
          //console.error(res)
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
  return promise
}

/**
 * 上传文件
 * @param {*} url
 * @param {*} formData  FormData
 * @param {*} params
 * @param {*} ignoreError
 */
export const upload = function(url, formData, params = {}, ignoreError) {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'post',
      params: params,
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: getAuthorization()
      },
      url: addFixedUrlParam(url)
    })
      .then(res => {
        if (res.status === 200) {
          resolve(res)
        } else {
          console.log('post.then.reject=' + res)
          reject(res)
        }
      })
      .catch(err => {
        console.log('post.catch.reject=' + err)
        reject(err)
      })
  })
  return promise
}

export const login = function(url, args) {
  let promise = new Promise((resolve, reject) => {
    axios({
      method: 'Post',
      data: args,
      headers: {
        'Content-type': 'application/x-www-form-urlencoded',
        Authorization: 'Basic Y2xpZW50XzI6MTIzNDU2'
      },
      url: addFixedUrlParam(url)
    })
      .then(res => {
        if (res.status === 200) {
          setLoginData(res.response.data)
          store.dispatch('reloadLoginBar') //重新加载登陆信息导航栏（PC端用）
          resolve(res)
        } else {
          reject(res)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
  return promise
}

/**
 * 登陆后设置登陆数据到Storage中
 * @param {*} data
 */
export const setLoginData = function(data) {
  sessionStorageUtil.set('token', data.access_token)
  sessionStorageUtil.set('token_type', data.token_type)
  sessionStorageUtil.set('refresh_token', data.refresh_token)
  sessionStorageUtil.set('refresh_token_time', setRefreshTokenTime()) //设置令牌刷新时间
  sessionStorageUtil.set('login_type', data.login_type)
  //设置cookie
  cookieUtil.set('new_token', data.access_token)
  cookieUtil.set('new_token_type', data.token_type)
  cookieUtil.set('new_refresh_token', data.refresh_token)
  cookieUtil.set('new_refresh_token_time', setRefreshTokenTime())
  cookieUtil.set('new_login_type', data.login_type)
  if (data.open_id) {
    sessionStorageUtil.set('open_id', data.open_id)
    cookieUtil.set('new_open_id', data.open_id)
  }
  //为了处理多窗口登陆问题
  localStorageUtil.set('token', data.access_token)
  if (data.login_type == 0) {
    //销售
    sessionStorageUtil.set('agent_username', data.username)
    sessionStorageUtil.set('category_code', data.category_code)
    sessionStorageUtil.set('customer_service_name', data.customer_service_name)
    cookieUtil.set('new_agent_username', data.username)
    cookieUtil.set('new_category_code', data.category_code)
    cookieUtil.set('new_customer_service_name', data.customer_service_name)
    if (data.domain_name && data.web_type) {
      sessionStorageUtil.set('domain_name', data.domain_name)
      sessionStorageUtil.set('web_type', data.web_type)
      cookieUtil.set('new_domain_name', data.domain_name)
      cookieUtil.set('new_web_type', data.web_type)
    } else {
      sessionStorageUtil.remove('domain_name')
      sessionStorageUtil.remove('web_type')
      cookieUtil.remove('new_domain_name')
      cookieUtil.remove('new_web_type')
    }
    sessionStorageUtil.remove('username')
    cookieUtil.remove('new_username')
  } else if (data.login_type == 1) {
    //会员
    sessionStorageUtil.set('member_id', data.member_id)
    sessionStorageUtil.set('bind_agent', data.bind_agent)
    sessionStorageUtil.set('name', data.name)
    sessionStorageUtil.set('username', data.cusername)
    sessionStorageUtil.set('member_types', data.member_types)

    //设置cookie
    cookieUtil.set('new_member_id', data.member_id)
    cookieUtil.set('new_bind_agent', data.bind_agent)
    cookieUtil.set('new_name', data.name)
    cookieUtil.set('new_username', data.cusername)
    cookieUtil.set('new_member_types', data.member_types)
    if (data.web_type && data.domain_name) {
      // sessionStorageUtil.remove('wechat_carry_demain')  //微信端链接携带域名标识，只作用一次（即微信端跳转做自动登陆时）
      sessionStorageUtil.set('domain_name', data.domain_name)
      sessionStorageUtil.set('web_type', data.web_type)
      cookieUtil.set('new_domain_name', data.domain_name)
      cookieUtil.set('new_web_type', data.web_type)
    }
    sessionStorageUtil.remove('agent_username')
    cookieUtil.remove('new_agent_username')
  } else {
    console.error('登陆类型未设置!')
    return false
  }

  //登陆时设置定时刷新临牌
  intervalRefreshToken()
  return true
}

/**
 * 退出登陆,撤销令牌,清理token（销售、会员）,不做后续跳转
 */
export const exitLogin = function() {
  let promise = new Promise((resolve, reject) => {
    get('oauth/revoke_token')
      .then(res => {
        //注销刷新令牌的定时器
        clearIntervalRefreshToken()
        sessionStorageUtil.remove('token')
        sessionStorageUtil.remove('token_type')
        sessionStorageUtil.remove('refresh_token')
        sessionStorageUtil.remove('refresh_token_time')
        localStorageUtil.remove('token')
        //清空cookie中的token相关
        cookieUtil.remove('new_token')
        cookieUtil.remove('new_token_type')
        cookieUtil.remove('new_refresh_token')
        cookieUtil.remove('new_refresh_token_time')
        let type = sessionStorageUtil.get('login_type')
        sessionStorageUtil.remove('login_type') //TODO xsw 是否清理login_type？
        if (type == 0) {
          sessionStorageUtil.remove('agent_username')
          sessionStorageUtil.remove('category_code')
        } else if (type == 1) {
          sessionStorageUtil.remove('username')
          sessionStorageUtil.remove('name')
          sessionStorageUtil.remove('bind_agent')
          sessionStorageUtil.remove('member_types')
          sessionStorageUtil.remove('member_id')
        }
        store.dispatch('reloadLoginBar') //重新加载登陆信息导航栏（PC端用）
        resolve(res)
      })
      .catch(err => {
        console.error('请求出错:[' + err.status + ']' + err.message, 'error')
        reject(err)
      })
  })
  return promise
}

/**
 * 获取token的剩余有效时间，为负数表示已经过期（时间戳以13位计算）
 * @param {*} token 临牌
 */
export const getTokenExp = function(token) {
  var jwt = require('jsonwebtoken')
  const token_obj = jwt.decode(token)
  if (!token_obj) {
    return -1
  }
  const exp = token_obj.exp * 1000
  const now_date = Date.parse(new Date())
  const tdoa = exp - now_date
  return tdoa
}

/**
 * 获取刷新令牌的剩余有效时间，为负数表示已经过期
 */
export const getRefreshTokenExp = function() {
  return getTokenExp(sessionStorageUtil.get('token'))
}

/**
 * 设置令牌刷新时间，登陆成功后
 */
export const setRefreshTokenTime = function() {
  const token = sessionStorageUtil.get('token') //获取临牌
  return getTokenExp(token) - 1000 * 60 * 5
}

/**
 * [xsw 20181104]
 * 定时刷新令牌
 */
export const intervalRefreshToken = function() {
  const token = sessionStorageUtil.get('token') //获取临牌
  if (token && token == localStorageUtil.get('token')) {
    //有令牌才设置定时刷新令牌
    const tdoa = getTokenExp(token)
    if (tdoa < 0) {
      //TODO [xsw] 所有令牌相关全部设置为空？？？？
      sessionStorageUtil.remove('token')
      sessionStorageUtil.remove('token_type')
      sessionStorageUtil.remove('refresh_token')
      localStorageUtil.remove('token')
      //清空cookie中的token相关
      cookieUtil.remove('new_token')
      cookieUtil.remove('new_token_type')
      cookieUtil.remove('new_refresh_token')
      if (confirm('登陆信息已经过期，是否重新登陆?')) {
        sessionStorageUtil.set('next_message', '登陆信息过期，重新登陆', 60 * 5)
        const login_type = sessionStorageUtil.get('login_type')
        const name = login_type == 0 ? 'agentLogin' : 'login'
        pushByName(name)
      }
    } else {
      //令牌失效前5分钟刷新,不足5分钟直接刷新
      const delayed_tdoa = tdoa - 1000 * 60 * 5
      const delayed_time = delayed_tdoa > 0 ? delayed_tdoa : 0 //delayed_time时间后设置定时任务
      //refresh_token_time为定时任务的时间间隔
      const refresh_token_time = sessionStorageUtil.get('refresh_token_time')
        ? sessionStorageUtil.get('refresh_token_time')
        : 1000 * 60 * 20 //如果没有设置为20分钟
      clearIntervalRefreshToken()
      setTimeout(function() {
        var refreshTokenTimer = setInterval(() => {
          if (
            sessionStorageUtil.get('token') == localStorageUtil.get('token')
          ) {
            console.log(
              '====>>>刷新令牌的定时任务(' +
                globalConfig.refreshTokenTimer +
                ')开始执行'
            )
            const Qs = require('qs')
            var url = 'oauth/token'
            var args = Qs.stringify({
              grant_type: 'refresh_token',
              refresh_token: sessionStorageUtil.get('refresh_token')
            })
            axios({
              method: 'Post',
              data: args,
              headers: {
                'Content-type': 'application/x-www-form-urlencoded',
                Authorization: 'Basic Y2xpZW50XzI6MTIzNDU2'
              },
              url: addFixedUrlParam(url)
            })
              .then(res => {
                if (res.status === 200) {
                  sessionStorageUtil.set(
                    'token',
                    res.response.data.access_token
                  )
                  sessionStorageUtil.set(
                    'token_type',
                    res.response.data.token_type
                  )
                  sessionStorageUtil.set(
                    'refresh_token',
                    res.response.data.refresh_token
                  )
                  localStorageUtil.set('token', res.response.data.access_token)
                } else {
                  console.log('服务器异常，请重试或联系管理员!')
                }
              })
              .catch(err => {
                console.log('临牌刷新失败')
              })
          } else {
            clearIntervalRefreshToken()
          }
        }, refresh_token_time)
        globalConfig.refreshTokenTimer = refreshTokenTimer
        console.log(
          '====>>>刷新令牌的定时任务(' +
            globalConfig.refreshTokenTimer +
            ')设置成功'
        )
      }, delayed_time)
    }
  }
}

/**
 * [xsw 20181104]
 * 注销刷新令牌的定时器
 */
export const clearIntervalRefreshToken = function() {
  clearInterval(globalConfig.refreshTokenTimer)
  console.log(
    '===>>>刷新令牌的定时器(' + globalConfig.refreshTokenTimer + ')已经注销'
  )
}

/**
 * 从旧项目跳转到新项目需要设置一些参数
 * 从旧项目跳转到新项目都要先执行这个方法
 * 操作
 *   1.设置domain_name
 *   2.设置web_type
 * return 10:代表不是旧项目访问新项目   1:是旧项目访问新项目，且参数设置成功    -1:是旧项目访问新项目，但web_type参数设置失败
 */
export const oldWeb2NewWebSetParam = function() {
  let promise = new Promise((resolve, reject) => {
    let query = router.currentRoute.query
    let bool = query.is_old_web2new_web //判断是否是从旧项目跳转到新项目
    if (bool) {
      let domain_name = query.domain_name
      let web_type = query.web_type
      sessionStorageUtil.set('domain_name', domain_name)
      sessionStorageUtil.set('web_type', web_type ? web_type : 1)
      cookieUtil.set('new_domain_name', domain_name)
      cookieUtil.set('new_web_type', web_type ? web_type : 1)
    } else {
      resolve(10) //返回10代表不是旧项目访问新项目
    }
  })
  return promise
}

/**
 * query通过参数传入,适用于被路由拦截拦截后的参数设置
 * 从旧项目跳转到新项目需要设置一些参数
 * 从旧项目跳转到新项目都要先执行这个方法
 * 操作
 *   1.设置domain_name
 *   2.设置web_type
 * @param {*} query
 * return 10:代表不是旧项目访问新项目   1:是旧项目访问新项目，且参数设置成功    -1:是旧项目访问新项目，但web_type参数设置失败
 */
export const interceptOldWeb2NewWebSetParam = function(query) {
  let promise = new Promise((resolve, reject) => {
    let bool = query.is_old_web2new_web //判断是否是从旧项目跳转到新项目
    if (bool) {
      let domain_name = query.domain_name
      let web_type = query.web_type
      sessionStorageUtil.set('domain_name', domain_name)
      sessionStorageUtil.set('web_type', web_type ? web_type : 1)
      cookieUtil.set('new_domain_name', domain_name)
      cookieUtil.set('new_web_type', web_type ? web_type : 1)
    } else {
      resolve(10) //返回10代表不是旧项目访问新项目
    }
  })
  return promise
}

/**
 * 判断是否登陆
 * @param {*} login_type 要判断的登陆类型：1:会员  0:销售  -1:会员或销售登陆都行
 */
export const isLogin = function(login_type = 1) {
  let bool = false
  if (
    sessionStorageUtil.get('token') &&
    sessionStorageUtil.get('refresh_token') &&
    getRefreshTokenExp() > 0
  ) {
    if (login_type == 1) {
      if (
        sessionStorageUtil.get('username') &&
        sessionStorageUtil.get('login_type') == 1
      ) {
        bool = true
      } else {
        bool = false
      }
    } else if (login_type == 0) {
      if (
        sessionStorageUtil.get('agent_username') &&
        sessionStorageUtil.get('login_type') == 0
      ) {
        bool = true
      } else {
        bool = false
      }
    } else if (login_type == -1) {
      if (
        (sessionStorageUtil.get('agent_username') &&
          sessionStorageUtil.get('login_type') == 0) ||
        (sessionStorageUtil.get('username') &&
          sessionStorageUtil.get('login_type') == 1)
      ) {
        bool = true
      } else {
        bool = false
      }
    }
  }
  return bool
}

/**
 * 登陆了返回登陆类型，未登陆返回-10
 * 登陆类型：1:会员  0:销售   2:游客
 */
export const loginType = function() {
  let type = 1
  if (
    sessionStorageUtil.get('token') &&
    sessionStorageUtil.get('refresh_token') &&
    getRefreshTokenExp() > 0
  ) {
    if (
      sessionStorageUtil.get('username') &&
      sessionStorageUtil.get('login_type') == 1
    ) {
      //会员/游客  登陆
      if (sessionStorageUtil.get('member_types') == 0) {
        type = 2
      }
      return type
    } else if (
      sessionStorageUtil.get('agent_username') &&
      sessionStorageUtil.get('login_type') == 0
    ) {
      //销售登陆
      type = 0
      return type
    }
  }
  return -10
}

/**
 * 跳转封装,通过name，传参方式query
 * @param {*} name 跳转的路由名称
 * @param {*} param 要传递的参数，json对象，如：param = {name:'aaa',id=1154}
 */
export const pushByName = function(name, param) {
  if (param) {
    router.push({
      name: name,
      query: param
    })
  } else {
    router.push({
      name: name
    })
  }
}

/**
 * 跳转封装,通过path，传参方式query
 * @param {*} name 跳转的路由名称
 * @param {*} param 要传递的参数，json对象，如：param = {name:'aaa',id=1154}
 */
export const pushByPath = function(path, param) {
  if (param) {
    router.push({
      path: path,
      query: param
    })
  } else {
    router.push({
      path: path
    })
  }
}

/**
 * 弹出子窗口，居中显示
 */
export const popupCenter = function(route_name, param = {}) {
  let routeData = router.resolve({
    name: route_name,
    query: param
  })
  var url = routeData.href //转向网页的地址
  var iWidth = window.screen.width - 500 //弹出窗口的宽度;
  var iHeight = 700 //弹出窗口的高度;
  var iTop = (window.screen.height - 30 - iHeight) / 2 //获得窗口的垂直位置
  var iLeft = (window.screen.width - 10 - iWidth) / 2 //获得窗口的水平位置
  window.open(
    url,
    route_name,
    'height=' +
      iHeight +
      ',,innerHeight=' +
      iHeight +
      ',width=' +
      iWidth +
      ',innerWidth=' +
      iWidth +
      ',top=' +
      iTop +
      ',left=' +
      iLeft +
      ',toolbar=no,menubar=no,scrollbars=auto,resizeable=no,location=no,status=no'
  )
}



// WEBPACK FOOTER //
// ./src/api/base.js